import { ActionsState } from './../store/reducers/Actions';

export const isStateLoading = (state: ActionsState, ...stateKeys: (keyof ActionsState)[]) => {
  return stateKeys.reduce((result, key) => result || state[key].inProgress, false);
};
